import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {BaseColonistStoreProduct, StoreProductType, StripeCheckoutTypes} from './BaseColonistStoreProduct'

// TODO: Membership Check
// persisted enum, do not delete or change existing entries
export enum ColonistCoinType {
    CoinType1 = 0,
    CoinType2 = 1,
    CoinType3 = 2,
    CoinType4 = 3,
    CoinType5 = 4,
    CoinType6 = 5,
}

export enum MobileCoinIAPSKUIds {
    CoinType1 = 'coin_id_1',
    CoinType2 = 'coin_id_2',
    CoinType3 = 'coin_id_3',
    CoinType4 = 'coin_id_4',
    CoinType5 = 'coin_id_5',
    CoinType6 = 'coin_id_6',
}

export class ColonistCoinProduct implements BaseColonistStoreProduct {
    // BaseColonistStoreProduct
    readonly storeProductType: StoreProductType = StoreProductType.Coin
    readonly type: ColonistCoinType
    readonly lobbyImage: LobbyImage
    readonly stripePriceId: string
    readonly stripeCheckoutType: StripeCheckoutTypes = StripeCheckoutTypes.Payment
    readonly itemQuantity: number = 1
    readonly discordSKUId: string
    // BaseColonistStoreProduct
    readonly baseCoinAmount: number
    readonly bonusCoinAmount: number
    readonly price: number
    readonly bannerText: TranslationObject | undefined
    readonly mobileIAPSKUId: string

    readonly isActive: () => boolean

    constructor(source: Pick<ColonistCoinProduct, 'type' | 'lobbyImage' | 'discordSKUId' | 'baseCoinAmount' | 'bonusCoinAmount' | 'price' | 'bannerText' | 'isActive' | 'mobileIAPSKUId'>) {
        Object.assign(this, source)
    }

    // BaseColonistStoreProduct
    getProductName(): TranslationObject {
        const coinTranslation: TranslationObject = {
            key: 'strings:storePage.coins.title',
            options: {
                count: this.getTotalCoinAmount(),
            },
        }
        return coinTranslation
    }

    getDefaultPrice(): string {
        return this.getUSDPriceWithSign()
    }
    // BaseColonistStoreProduct

    getTotalCoinAmount(): number {
        return this.baseCoinAmount + this.bonusCoinAmount
    }

    getUSDPrice(): number {
        return this.price / 100
    }

    getUSDPriceWithSign(): string {
        return `$${this.getUSDPrice()}`
    }

    static getAllCoinProducts(): IterableIterator<ColonistCoinProduct> {
        return this.products.values()
    }

    static getPurchaseProduct(coinType: ColonistCoinType): ColonistCoinProduct {
        return this.products.get(coinType) as ColonistCoinProduct
    }

    private static readonly products = new Map<ColonistCoinType, ColonistCoinProduct>()

    static initProducts(discordSKUIds: Record<string, string>) {
        this.products.set(ColonistCoinType.CoinType1, new ColonistCoinProduct({
            type: ColonistCoinType.CoinType1,
            baseCoinAmount: 650,
            bonusCoinAmount: 0,
            price: 499,
            discordSKUId: discordSKUIds.coin1,
            mobileIAPSKUId: MobileCoinIAPSKUIds.CoinType1,
            lobbyImage: LobbyImage.CoinStack1,
            bannerText: undefined,
            isActive: () => true,
        }))

        this.products.set(ColonistCoinType.CoinType2, new ColonistCoinProduct({
            type: ColonistCoinType.CoinType2,
            baseCoinAmount: 1300,
            bonusCoinAmount: 80,
            price: 999,
            discordSKUId: discordSKUIds.coin2,
            mobileIAPSKUId: MobileCoinIAPSKUIds.CoinType2,
            lobbyImage: LobbyImage.CoinStack2,
            bannerText: undefined,
            isActive: () => true,
        }))

        this.products.set(ColonistCoinType.CoinType3, new ColonistCoinProduct({
            type: ColonistCoinType.CoinType3,
            baseCoinAmount: 2600,
            bonusCoinAmount: 400,
            price: 1999,
            discordSKUId: discordSKUIds.coin3,
            mobileIAPSKUId: MobileCoinIAPSKUIds.CoinType3,
            lobbyImage: LobbyImage.CoinStack3,
            bannerText: undefined,
            isActive: () => true,
        }))

        this.products.set(ColonistCoinType.CoinType4, new ColonistCoinProduct({
            type: ColonistCoinType.CoinType4,
            baseCoinAmount: 4500,
            bonusCoinAmount: 800,
            price: 3499,
            discordSKUId: discordSKUIds.coin4,
            mobileIAPSKUId: MobileCoinIAPSKUIds.CoinType4,
            lobbyImage: LobbyImage.CoinStack4,
            bannerText: {key: 'strings:storePage.bestSeller'},
            isActive: () => true,
        }))

        this.products.set(ColonistCoinType.CoinType5, new ColonistCoinProduct({
            type: ColonistCoinType.CoinType5,
            baseCoinAmount: 6500,
            bonusCoinAmount: 1300,
            price: 4999,
            discordSKUId: discordSKUIds.coin5,
            mobileIAPSKUId: MobileCoinIAPSKUIds.CoinType5,
            lobbyImage: LobbyImage.CoinStack5,
            bannerText: undefined,
            isActive: () => true,
        }))

        this.products.set(ColonistCoinType.CoinType6, new ColonistCoinProduct({
            type: ColonistCoinType.CoinType6,
            baseCoinAmount: 13000,
            bonusCoinAmount: 3000,
            price: 9999,
            discordSKUId: discordSKUIds.coin6,
            mobileIAPSKUId: MobileCoinIAPSKUIds.CoinType6,
            lobbyImage: LobbyImage.CoinStack6,
            bannerText: {key: 'strings:storePage.bestValue'},
            isActive: () => true,
        }))
    }
}
